import i18n from '@/main';
import http from '@/utils/http';

const baseUrl = '/monitoramento';

export default {
    monitoramentoAgro(idAreaMonitorada) {
        return http.get({
            url: baseUrl + `/agro/${idAreaMonitorada}`,
            lockScreen: false
        });
    },

    monitoramentoClimatico(idAreaMonitorada) {
        return http.get({
            url: baseUrl + `/climatico/${idAreaMonitorada}`,
            lockScreen: false
        });
    },

    envioAreaMonitoramento(objetoMonitoramento) {
        return http.post({
            url: baseUrl + `/envio-area-monitoramento`,
            data: objetoMonitoramento,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.enviandoTerritorioParaMonitoramento'
            )
        });
    },

    verificarTerritorio(idTerritorio) {
        return http.get({
            url: baseUrl + `/verificar?idTerritorio=${idTerritorio}`,
            lockScreen: false
        });
    },

    editarAreaMonitoramento(objetoMonitoramento) {
        return http.post({
            url: baseUrl + `/editar-area-monitoramento`,
            data: objetoMonitoramento,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.salvandoEdicao')
        });
    },

    cancelarMonitoramento(idAreaMonitorada) {
        return http.put({
            url: baseUrl + `/remover-area-monitoramento/${idAreaMonitorada}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.cancelandoMonitoramento')
        });
    },

    dadosPlantio(idAreaMonitorada) {
        return http.get({
            url: baseUrl + `/${idAreaMonitorada}/dadosPlantio`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDePlantio')
        });
    },

    buscaAreaMonitorada(idTerritorio) {
        return http.get({
            url:
                baseUrl +
                `/buscar-area-monitorada/?idTerritorio=${idTerritorio}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoAreaMonitorada')
        });
    },

    reativarMonitoramento(idAreaMonitorada) {
        return http.get({
            url: baseUrl + `/reativar-area-monitorada/${idAreaMonitorada}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.reativandoMonitoramento')
        });
    },

    verificarMonitoramentoAtivo(idAreaMonitorada) {
        return http.get({
            url: baseUrl + `/verificar-ativo/${idAreaMonitorada}`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.verificandoMonitoramentosAtivos'
            )
        });
    },

    getDataUltimaAtualizacao(idAreaMonitorada) {
        return http.get({
            url: baseUrl + `/${idAreaMonitorada}/data-ultima-atualizacao`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoDataDaUltimaAtualizacao'
            )
        });
    }
};
